import { accountsEnvironment } from '../accounts-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { configurationSettingsListSchema } from '../schemas/configuration-settings-list.schema';
import { AuthHeaders } from '../../../models/auth-headers';
import { fromFetch } from 'rxjs/fetch';

/**
 * Get a list of Configuration Settings for a specified Account
 * @param accountAlias Alias of the Account
 * @param includeOverride Include overrides in the response
 * @returns A list of Configuration Settings
 */
export function getConfigurationSettingsAccountAlias(
  this: unknown,
  accountAlias: string,
  includeOverride = false
) {
  const param = new URLSearchParams([
    ['includeOverride', String(includeOverride)],
  ]);
  return withJwt(() =>
    fromFetch(
      new Request(
        `${
          accountsEnvironment.resolve(this).configurationSettingsUrl
        }/account/${encodeURIComponent(accountAlias)}?${param.toString()}`,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...new AuthHeaders(), // Doesn't work with JWT for some reason
          },
        }
      )
    )
  ).pipe(selectData(configurationSettingsListSchema));
}
